module.exports = __webpack_public_path__ + "static/media/ayuda-instalador.97152dc9.jpg";